"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientItem = exports.name = void 0;
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const theme_1 = require("theme");
const orders_1 = require("components/partial/orders");
const NewQuote_1 = require("components/partial/NewQuote");
const Quotes_1 = require("components/partial/Quotes");
const QuoteDetail_1 = require("components/partial/QuoteDetail");
const PlanningRoadmapAdd_1 = require("components/partial/PlanningRoadmapAdd");
const PlanningRoadmapEditNewAdic_1 = require("components/partial/PlanningRoadmapEditNewAdic");
const RequirementRequestAdd_1 = require("components/partial/RequirementRequestAdd");
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const context_1 = require("components/context");
const services_1 = require("services");
const constants_1 = require("constants/constants");
const native_1 = require("@react-navigation/native");
const modal_1 = require("components/modal");
const NewQuote_2 = require("types/components/partial/NewQuote");
const Clients = ({ navigation, route }) => {
    const { origin } = route?.params ?? {};
    const authContext = React.useContext(context_1.AuthContext);
    let offset = React.useRef(0);
    const timeoutID = React.useRef(null);
    const [queryToSearch, setQueryToSearch] = React.useState("");
    const onQueryChange = React.useCallback((query) => {
        clearTimeout(timeoutID.current);
        const id = setTimeout(() => {
            setQueryToSearch(query);
        }, 800);
        timeoutID.current = id;
    }, [timeoutID.current]);
    const [initialLoading, setInitialLoading] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const lastPage = React.useRef(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const blockRequest = React.useRef(false);
    const [clients, setClients] = React.useState();
    const loadClientsBase = React.useCallback(({ callback, page }) => {
        (0, services_1.doClientes)({
            params: {
                q: queryToSearch,
                page: page,
            },
            callback,
        });
    }, [queryToSearch]);
    const loadClients = () => {
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            setClients(response.data);
        };
        const onFailSessionExpired = authContext?.signOut;
        loadClientsBase({
            callback: {
                onSuccess,
                onLoading: setInitialLoading,
                onFailSessionExpired,
            },
            page: 1,
        });
    };
    const loadMoreClients = React.useCallback(() => {
        let nextPage = currentPage + 1;
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            //if ((response?.data?.length ?? 0) === 0) hasMore.current = false;
            if (response?.data?.length ?? 0 > 0) {
                setClients(clients => [...(clients ?? []), ...(response?.data ?? [])]);
                setCurrentPage(nextPage);
            }
            blockRequest.current = false;
        };
        const onFail = (e) => {
            blockRequest.current = false;
        };
        loadClientsBase({
            callback: {
                onSuccess,
                onFail,
                onLoading: setLoading,
            },
            page: nextPage,
        });
    }, [currentPage, lastPage.current, blockRequest.current]);
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        loadClients();
    }, [queryToSearch]));
    React.useEffect(() => {
        //loadClients();
    }, []);
    const numColumns = (0, native_base_1.useBreakpointValue)({
        base: 1,
        xl: 2,
    });
    const onClientPress = (client) => {
        //si hemos ingresado por el modulo de cotizaciones
        const saveAndNotifyClient = async () => {
            await async_storage_1.default.setItem(constants_1.StorageKey.CLIENT_DATA, JSON.stringify(client));
            authContext?.onClientChange();
        };
        if (origin == "NewQuote") {
            const clientChange = async () => {
                await saveAndNotifyClient();
                navigation.navigate({
                    name: NewQuote_1.name,
                    params: {
                        client: client,
                        clientType: NewQuote_2.EClientType.CLIENT_EXISTENT,
                    },
                    merge: false,
                });
            };
            clientChange();
        }
        else if (origin == "Quotes") {
            const clientChange = async () => {
                await saveAndNotifyClient();
                navigation.jumpTo(Quotes_1.name, {
                    clientForTransformQuote: client,
                });
            };
            clientChange();
        }
        else if (origin == "QuoteDetail") {
            const clientChange = async () => {
                await saveAndNotifyClient();
                navigation.navigate(QuoteDetail_1.name, {
                    clientForTransformQuote: client,
                    id: route?.params?.quoteId,
                    warehouseCode: route?.params?.quoteWarehouseCode,
                });
            };
            clientChange();
        }
        else if (origin == "PlanningRoadmapAdd") {
            const clientChange = async () => {
                await saveAndNotifyClient();
                navigation.navigate({
                    name: PlanningRoadmapAdd_1.name,
                    params: {
                        client: client,
                        clear: false,
                    },
                    merge: true,
                });
            };
            clientChange();
        }
        else if (origin == "PlanningRoadmapEditNewAdic") {
            const clientChange = async () => {
                //await saveAndNotifyClient();
                navigation.navigate({
                    name: PlanningRoadmapEditNewAdic_1.name,
                    params: {
                        id: route.params?.roadmapId,
                        client: client,
                        clear: false,
                    },
                    merge: true,
                });
            };
            clientChange();
        }
        else if (origin == "RequirementRequestAdd") {
            const clientChange = async () => {
                await saveAndNotifyClient();
                navigation.navigate({
                    name: RequirementRequestAdd_1.name,
                    params: {
                        client: client,
                        clear: false,
                    },
                    merge: true,
                });
            };
            clientChange();
        }
        else {
            const clientChange = async () => {
                await saveAndNotifyClient();
                navigation.jumpTo(orders_1.name);
            };
            clientChange();
        }
    };
    const onContactPress = React.useCallback((phone) => {
        const url = `tel:${phone}`;
        react_native_1.Linking.canOpenURL(url)
            .then(supported => {
            react_native_1.Linking.openURL(url);
        })
            .catch(err => {
            console.log("err", err);
        });
    }, []);
    const renderItem = ({ item }) => (<ClientItem onClientPress={onClientPress} onContactPress={onContactPress} style={styles.layoutClient} client={item}/>);
    return (<>
			<native_base_1.VStack style={styles.container}>
				<MemorizedSearchClient onQueryChange={onQueryChange}/>

				<native_base_1.FlatList h="100%" w="100%" marginTop={10} px={{ base: 20, md: 40 }} data={clients} extraData={clients?.length} renderItem={renderItem} numColumns={numColumns} key={`${numColumns} ${queryToSearch}`} keyExtractor={(item, index) => {
            return item?.id ?? "";
        }} ItemSeparatorComponent={() => {
            return <native_base_1.View height="1"></native_base_1.View>;
        }} ListFooterComponent={() => (<native_base_1.View style={{ marginBottom: 300, marginTop: "10" }} maxHeight="400">
							{isLoading && <native_base_1.Spinner size="lg" color="black"/>}
						</native_base_1.View>)} onScroll={e => {
            let paddingToBottom = 4000;
            paddingToBottom += e.nativeEvent.layoutMeasurement.height;
            var currentOffset = e.nativeEvent.contentOffset.y;
            var direction = currentOffset > offset.current ? "down" : "up";
            if (direction === "down") {
                if (e.nativeEvent.contentOffset.y >= e.nativeEvent.contentSize.height - paddingToBottom) {
                    if (!isLoading && currentPage < lastPage.current && !blockRequest.current) {
                        blockRequest.current = true;
                        setTimeout(() => {
                            loadMoreClients();
                        }, 10);
                    }
                }
            }
            offset.current = currentOffset;
        }} initialNumToRender={20} maxToRenderPerBatch={20}/>
			</native_base_1.VStack>

			<FullScreenLoad_1.default isVisible={initialLoading}/>
			<BannerModal />
			<DeudaModal />
		</>);
};
const SearchClient = ({ onQueryChange }) => {
    const [query, setQuery] = React.useState("");
    const handleChange = (event) => {
        setQuery(event.target.value);
        onQueryChange(event.target.value);
    };
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        setQuery((query) => {
            if (query) {
                onQueryChange("");
                return "";
            }
            else {
                return query;
            }
        });
    }, []));
    return (<native_base_1.Input value={query} onChange={handleChange} InputRightElement={<native_base_1.Image source={require("images/ic_search.svg")} variant="iconInputRight" alt="icono de busqueda"/>} minWidth={{ base: "95%", md: 400 }} placeholder={theme_1.Str.searchClient} borderRadius="50" borderWidth="0" alignSelf={{
            base: "center",
            md: "flex-end",
        }} px="10" mt={{ base: 20, md: 30 }} mx={{ base: 20, md: 40 }}/>);
};
const MemorizedSearchClient = React.memo(SearchClient);
const ClientItem = ({ onClientPress, onContactPress, style, client }) => {
    const route = (0, native_1.useRoute)();
    const onTelPress = React.useCallback(() => {
        onContactPress?.(client?.tel ?? "");
    }, [client?.tel]);
    const onPress = React.useCallback(() => {
        if (client)
            onClientPress?.(client);
    }, [route?.params?.origin, client?.id]);
    return (<native_base_1.Pressable onPress={onPress} style={[theme_1.Styles.box, style, stylesClient.container]} minW={{ base: "100%", md: 300 }} mt={{ base: 10, md: 20 }} mx={{ base: 0, md: 10 }} px={{ base: 12, md: 20 }} py={{ base: 10, md: 20 }}>
			<native_base_1.View style={stylesClient.layoutClientPhone}>
				<native_base_1.Text style={stylesClient.txtClient} variant="h23">
					{client?.nombre}
				</native_base_1.Text>
				<native_base_1.Button onPress={onTelPress} style={[stylesClient.btnCellPhoneNumber]} startIcon={<native_base_1.Image source={require("images/ic_phone.svg")} variant={{
                base: "iconButtonLeftXs",
                md: "iconButtonLeftSm",
            }} alt={theme_1.Str.alt.ic_phone}/>} size={{ base: "xs", md: "sm" }} py={{ base: 2, md: 4 }}>
					{client?.tel}
				</native_base_1.Button>
			</native_base_1.View>
			<native_base_1.HStack mt="5">
				<native_base_1.Text style={stylesClient.txtRucEmailAddressTitle} variant="body4">
					{theme_1.Str.code + ": "}
				</native_base_1.Text>
				<native_base_1.Text style={stylesClient.txtRucEmailAddressTitle} variant="h4">
					{client?.id ?? ""}
				</native_base_1.Text>
			</native_base_1.HStack>

			<native_base_1.View style={stylesClient.layoutRucEmail} mt={{ base: 7, md: 15 }}>
				<native_base_1.View style={stylesClient.layoutRucEmailItem}>
					<native_base_1.Text style={stylesClient.txtRucEmailAddressTitle} variant="body6">
						{theme_1.Str.ruc}
					</native_base_1.Text>
					<native_base_1.Text style={stylesClient.txtRucEmailAddressValue} mt={{ base: 0, md: 4 }}>
						{client?.numerodoc}
					</native_base_1.Text>
				</native_base_1.View>
				<native_base_1.View style={stylesClient.layoutRucEmailItem}>
					<native_base_1.Text style={stylesClient.txtRucEmailAddressTitle} variant="body6">
						{theme_1.Str.e_mail_literal}
					</native_base_1.Text>
					<native_base_1.Text style={stylesClient.txtRucEmailAddressValue} mt={{ base: 0, md: 4 }}>
						{client?.email}
					</native_base_1.Text>
				</native_base_1.View>
			</native_base_1.View>
			<native_base_1.Text style={[stylesClient.txtRucEmailAddressTitle, stylesClient.txtAddressTitle]} variant="body6" mt={{ base: 7, md: 15 }}>
				{theme_1.Str.address}
			</native_base_1.Text>
			<native_base_1.Text style={stylesClient.txtRucEmailAddressValue} mt={{ base: 0, md: 4 }}>
				{client?.direccion}
			</native_base_1.Text>
		</native_base_1.Pressable>);
};
exports.ClientItem = ClientItem;
const MemorizedClientItem = React.memo(ClientItem);
const BannerModal = () => {
    const [showModal, setShowModal] = React.useState(false);
    const [banner, setBanner] = React.useState();
    React.useEffect(() => {
        const getBanner = async () => {
            const response = await async_storage_1.default.getItem(constants_1.StorageKey.BANNER);
            if (response) {
                const url = response;
                setBanner(url);
                setShowModal(true);
            }
        };
        getBanner();
    }, []);
    const onCloseModal = () => {
        const removeBanner = async () => {
            await async_storage_1.default.removeItem(constants_1.StorageKey.BANNER);
            setBanner("");
            setShowModal(false);
        };
        removeBanner();
    };
    return <modal_1.ModalBanner source={{ uri: banner }} isOpen={showModal} onClose={onCloseModal}/>;
};
const DeudaModal = () => {
    const [showModal, setShowModal] = React.useState(false);
    const [message, setMessage] = React.useState();
    React.useEffect(() => {
        const getBanner = async () => {
            const response = await async_storage_1.default.getItem(constants_1.StorageKey.DEUDA);
            if (response) {
                setMessage(response);
                setShowModal(true);
            }
        };
        getBanner();
    }, []);
    const onCloseModal = () => {
        const removeBanner = async () => {
            await async_storage_1.default.removeItem(constants_1.StorageKey.DEUDA);
            setMessage("");
            setShowModal(false);
        };
        removeBanner();
    };
    return <modal_1.ModalDeuda message={message} isOpen={showModal} onClose={onCloseModal}/>;
};
const stylesClient = react_native_1.StyleSheet.create({
    container: {},
    layoutClientPhone: {
        flexDirection: "row",
        alignItems: "center",
    },
    txtClient: {
        marginEnd: 20,
        flex: 1,
    },
    btnCellPhoneNumber: {
        borderRadius: 40,
    },
    layoutRucEmail: {
        flexDirection: "row",
    },
    layoutRucEmailItem: {
        flex: 1,
    },
    txtRucEmailAddressTitle: {
        textTransform: "uppercase",
    },
    txtRucEmailAddressValue: {},
    txtAddressTitle: {},
});
const styles = react_native_1.StyleSheet.create({
    container: {
        width: "100%",
        height: "100%",
    },
    btnSearchClientText: {
        textAlign: "left",
        flex: 1,
    },
    btnSearchClientIcon: {
        tintColor: theme_1.Colors.colorGray1,
    },
    layoutClient: {
        flex: 1,
    },
});
const name = "ClientsName";
exports.name = name;
exports.default = Clients;
